import { frontendURL } from 'dashboard/helper/URLHelper';

// Macros now live under Automations > Internal; keep old links working.
const redirectTo = name => to => ({ name, params: to.params });

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/macros'),
      redirect: redirectTo('automations_macros'),
    },
    {
      path: frontendURL('accounts/:accountId/settings/macros/new'),
      redirect: redirectTo('macros_new'),
    },
    {
      path: frontendURL('accounts/:accountId/settings/macros/:macroId/edit'),
      redirect: redirectTo('macros_edit'),
    },
  ],
};
